<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading"
        v-if="this.getDetailLink.wpdid !== ''">
          <div class="ml-4">
            {{getDetailLink.wpt}}
          </div>
          <v-spacer/>
          <div class="mr-4">
            Rev {{getDetailLink.wprev}}
          </div>
        </v-layout>
        <div v-if="this.getDetailBasic.tag !== 'M5'">
          <v-layout class="text-xs-left ml-2 mt-4 mr-2">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> assignment </v-icon>
              </v-avatar>
              Procedure
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> more_time</v-icon>
              </v-avatar>
              {{calcTaskListProgress(this.getTasksList)}}%
            </v-chip>
          </v-layout>
          <v-layout class="ml-4 mr-4">
            <v-progress-linear
              height="3"
              :background-color="ui.colorBlue"
              :color="ui.colorSuccess"
              :value="calcTaskListProgress(this.getTasksList)"
            ></v-progress-linear>
          </v-layout>
        </div>
        <Tasks/>
        <v-layout row class="mt-3 mr-2">
          <v-spacer/>
          <DocumentInfoCard
          v-if="this.getDetailLink.wpdid !== undefined && this.getDetailLink.wpdid !== ''"
          :data="{
            btn: 'icon',
            type: 'LINK',
            cdid: this.getUser.pref.select.cdid,
            fdid: this.getUser.pref.select.fdid,
            did: this.getDetailLink.wpdid,
            tag: 'W6'}"
          />
          <Append :data="{tag: 'W6'}"
          v-if="this.getDetail.basic.tag !== 'W2'"/>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import Tasks from "@/work/tasks/components/Tasks";
import Append from "@/data/append/components/Append";
import tasksFunctions from "@/data/functions/mixins/tasksFunctions.js";
import DocumentInfoCard from "@/document/info/components/DocumentInfoCard";
import { mapGetters } from "vuex";
export default {
  components: {
    Tasks,
    Append,
    DocumentInfoCard
  },
  data() {
    return {
      valid: true
    };
  },
  mixins: [apptheme, tasksFunctions],
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailBasic",
      "getDetailLink",
      "getTasksList",
      "getUser"
    ])
  }
};
</script>
